import React from 'react';
import { Modal, Form, Select, Input, Alert } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;
const { TextArea } = Input;

const UserModals = ({
  selectedUser,
  roleModalVisible,
  statusModalVisible,
  loading,
  onRoleModalClose,
  onStatusModalClose,
  onRoleUpdate,
  onStatusUpdate,
  form
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Modal pour modifier le rôle */}
      <Modal
        title={
          <span>
            {t('admin.user_modals.role_title')} <strong>{selectedUser?.username}</strong>
          </span>
        }
        open={roleModalVisible}
        onCancel={onRoleModalClose}
        onOk={onRoleUpdate}
        confirmLoading={loading}
        okText={t('admin.users_management.messages.update_success')}
        cancelText={t('common.cancel')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="role"
            label={t('admin.user_modals.new_role')}
            rules={[{ required: true, message: t('admin.user_modals.role_req') }]}
          >
            <Select placeholder={t('admin.user_modals.role_placeholder')}>
              <Option value="admin">{t('admin.user_modals.roles.admin')}</Option>
              <Option value="manager">{t('admin.user_modals.roles.manager')}</Option>
              <Option value="leader">{t('admin.user_modals.roles.leader')}</Option>
              <Option value="user">{t('admin.user_modals.roles.user')}</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal pour modifier le statut */}
      <Modal
        title={
          <span>
            {t('admin.user_modals.status_title')} <strong>{selectedUser?.username}</strong>
          </span>
        }
        open={statusModalVisible}
        onCancel={onStatusModalClose}
        onOk={onStatusUpdate}
        confirmLoading={loading}
        okText={t('admin.users_management.messages.update_success')}
        cancelText={t('common.cancel')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="status"
            label={t('admin.user_modals.new_status')}
            rules={[{ required: true, message: t('admin.user_modals.status_req') }]}
          >
            <Select placeholder={t('admin.user_modals.status_placeholder')}>
              <Option value="active">
                <span style={{ color: '#52c41a' }}>{t('admin.user_modals.statuses.active')}</span>
              </Option>
              <Option value="suspended">
                <span style={{ color: '#faad14' }}>{t('admin.user_modals.statuses.suspended')}</span>
              </Option>
              <Option value="banned">
                <span style={{ color: '#f5222d' }}>{t('admin.user_modals.statuses.banned')}</span>
              </Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="reason"
            label={t('admin.user_modals.reason')}
          >
            <TextArea 
              rows={3} 
              placeholder={t('admin.user_modals.reason_placeholder')} 
            />
          </Form.Item>
          
          {selectedUser?.account_status === 'active' && form.getFieldValue('status') !== 'active' && (
            <Alert
              message={t('admin.user_modals.warning_title')}
              description={t('admin.user_modals.warning_desc')}
              type="warning"
              showIcon
              style={{ marginBottom: '16px' }}
            />
          )}
        </Form>
      </Modal>
    </>
  );
};

export default UserModals;